export default "__VITE_ASSET__c5748a62__"